import ServicePageTemplate from "../../components/ServicePageTemplate";
import { IMAGES } from "../../lib/assets";

// NOTE TO MIGUEL / CONTENT EDITOR:
// Replace everything wrapped in [SQUARE BRACKETS] with final copy.

export default function ArtisanPlasteringPage() {
  return (
    <ServicePageTemplate
      seo={{
        slug: "artisan-plastering",
        // SEO TITLE — primary keywords: microcement, Venetian plaster,
        // decorative plaster Auckland
        title:
          "Microcement & Venetian Plaster Auckland | Artisan Plastering — Trust Flooring & Interiors",
        // META DESCRIPTION — 150–160 characters
        description:
          "Architectural plaster finishes across Auckland, Christchurch and New Zealand — microcement floors and walls, Venetian plaster and decorative finishes for high-end residential and commercial interiors.",
        canonical: "https://trustflooring.co.nz/services/artisan-plastering",
      }}
      eyebrow="Services — Artisan Plastering"
      h1="Artisan plaster finishes for architectural interiors."
      // [INSERT HERO IMAGE — microcement wall / Venetian plaster close-up / a
      // high-end feature finish]
      heroImage={IMAGES.plastering}
      // [INSERT IMAGE ALT TEXT — e.g. "microcement feature wall in an
      // architectural home, Auckland"]
      heroAlt="Microcement feature wall finish in an architectural residential interior, Auckland"
      intro={[
        // [INSERT INTRO PARAGRAPH 1 — keywords: microcement Auckland,
        // Venetian plaster New Zealand, decorative plaster finishes]
        "Trust Flooring & Interiors applies architectural plaster finishes — microcement, Venetian plaster and bespoke decorative finishes — across high-end residential and commercial interiors in Auckland, Christchurch and across New Zealand. These are specialist, hand-applied surfaces; each installation is tuned to the specification and light of the space.",
        // [INSERT INTRO PARAGRAPH 2 — secondary keywords: seamless plaster,
        // feature wall, bathroom microcement]
        "From seamless microcement bathrooms and kitchens to Venetian plaster feature walls, we work from sample-and-sign-off through to install, protecting adjacent trades and delivering a finish that holds up to daily use. [Replace this with a sentence on signature finishes or recent projects if relevant.]",
      ]}
      offerings={{
        heading: "Artisan plastering services we offer.",
        items: [
          "Microcement flooring and walls",
          "Venetian plaster",
          "Decorative plaster finishes",
          "Seamless architectural surfaces",
          "Custom designs",
        ],
      }}
      why={{
        heading: "Why specify Trust Flooring for artisan finishes.",
        // [INSERT WHY PARAGRAPH]
        paragraph:
          "Artisan plaster is unforgiving — the finish is the substrate. We prepare, sample and apply with the care a specification finish demands, and we're comfortable working on architecturally-led projects where tolerance and consistency matter.",
        points: [
          "Sample-and-approve process before site application",
          "Experienced applicators for microcement and Venetian systems",
          "Finishes suited to wet areas, feature walls and floors",
          "Careful coordination with joinery, tiling and lighting trades",
        ],
      }}
    />
  );
}
